import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import HealthPage from './pages/HealthPage.tsx';
import { TranslationProvider } from './hooks/useTranslation';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<TranslationProvider>
			<BrowserRouter>
				<Routes>
					<Route path='/health' element={<HealthPage />} />
					<Route path='*' element={<App />} />
				</Routes>
			</BrowserRouter>
		</TranslationProvider>
	</StrictMode>,
);
